module.exports = __webpack_public_path__ + "static/media/HighAngelOfAether11.21e40b3f.jpg";